<template>
  <div class="about history3">
    <h2 class="about-title">隆盛期<span class="about-title__year">1981-1990</span></h2>
    
    <div class="content1 section">
      <h3>オートバイブームの到来</h3>
      <div class="column">
        <p>70年代はモトクロスがモーターサイクル界を牽引していた。そして1980年代となると、日本には一大オートバイブームが訪れる。82年に公開された映画『汚れた英雄』をはじめ、週刊漫画誌に連載された作品は大人気となり、メーカーはこぞって新製品を市場へリリース。その熱気は、サーキットも包み込んだ。<br>特に隆盛を極めたのがロードレースだ。真夏の鈴鹿８時間耐久ロードレースは、毎年20万人を超える大観衆を集め、ひとつの社会現象として一般にも取り上げられ認知度を高めていく。全日本選手権でも平忠彦や宮城光といったスターライダーの登場で爆発的な人気を得ていた。</p>
        <figure><img src="/img/1981-1990-1.jpg" alt="" width="" height=""></figure>
      </div>
    </div>
    
    <div class="content2 img-content">
      <div class="img-content__bg">
        <div class="img-content__wrap">
          <div class="img-content__text">
            <h3>オートバイが社会に浸透</h3>
            <p>テレビ放映やオートバイ専門誌の創刊ラッシュも続き、オートバイが社会の中に浸透していったのが80年代だ。<br>ロードレースでは平が83〜85年に３年連続でGP500チャンピオンに、87〜89年には藤原儀彦が同じくGP500の３連覇を達成。モトクロスでは80年代の10年間に東福寺保雄が７回のチャンピオンに輝くなど全盛期を迎えた。さらに、トライアルでも82〜86年まで山本昌也が５連覇を達成。89年には90年代に世界選手権で活躍する成田匠が初の全日本IAチャンピオンに輝くなど、その後につながる出来事があった年代でもある。</p>
          </div>
          <figure><img src="/img/1981-1990-3.jpg" alt="" width="" height=""></figure>
        </div>
      </div>
    </div>
    
    <div class="content3 section">
      <div class="column">
        <figure><img src="/img/1981-1990-5.jpg" alt="" width="" height=""></figure>
        <figure><img src="/img/1981-1990-4.jpg" alt="" width="" height=""><figcaption>モトクロスも同じように多くのファンを集めた</figcaption></figure>
      </div>
      <p>また82年に東京・後楽園球場で開催されたスーパークロスは、日本のモトクロス界に大きな衝撃を与えた。ダイナミックな連続ジャンプを華麗に飛ぶ海外勢に、当初日本人選手はまったく歯が立たなかったが、開催を繰り返すうちに日本人選手の技量も上がり、連続ジャンプを飛ぶことも成功。スーパークロス自体も、都市部で開催されたため非常に高い人気を獲得し、冬の定番イベントとなっていった。</p>
    </div>
    
    <div class="content4 section">
      <h3>各競技での活躍</h3>
      <div class="column-02">
        <p>ロードレース、モトクロス、トライアルの各競技でも世界選手権終了後にトップライダーが全日本へと登場する機会が増え、選手たちに刺激を与えていった。そして気運が高まった1987年、ついにロードレース世界選手権が鈴鹿で復活。再びグランプリが多くの日本人ファンの前で開催されるようになったのだ。<br>底辺層では、ミニバイクが一大ブームを迎え、各地のミニサーキットや駐車場などを利用しレースが開催されるようになると、多くの愛好者を集めた。特に幼少からこうしてレースに親しむ環境にあった若い選手たちが、90年代に入るとその活躍の場をロードレース世界選手権などに移し、大活躍を演じることとなる。モトクロス、トライアルでも、このモーターサイクルブームによって幼いときにモーターサイクルスポーツを始めた年代が、90年代から長く日本のリーダー的役割を務める活躍をすることとなる。</p>
        <figure><img src="/img/1981-1990-6.jpg" alt="" width="" height=""><figcaption>８８年トライアル界を牽引した山本昌也（写真右）と伊藤敦志。８２〜８６年に山本が５連覇を達成、伊藤はその山本を破り８７年に初のタイトルを獲得。翌８８年も連覇を飾った。</figcaption></figure>
      </div>
    </div>
    
    <div class="content5 section">
      <figure><img src="/img/1981-1990-8.jpg" alt="" width="" height=""></figure>
    </div>

  </div>
</template>

<script>
export default {
  name: "tab1964",
};
</script>

<style lang="scss">
.history3 {
  figure {
    margin: 0;
    padding: 0;
    text-align: center;
  }
  figcaption {
    font-size: 12px;
    margin-top: 10px;
  }
  .content2 {
    background: url(/img/1981-1990-3.jpg) center center / cover no-repeat;
  }
  .column {
    display: flex;
    justify-content: flex-start;
    > * {
      width: 48%;
    }
    > *:first-child {
      margin-right: 2%;
    }
    @media(max-width: 1200px) {
      display: block;
      > * {
        width: 100%;
      }
      > *:first-child {
        margin-right: 0;
        margin-bottom: 20px;
      }
    }
  }
  .content4 {
    margin: 40px auto;
    h3 {
      margin-bottom: 15px;
    }
    p {
      margin: 0;
    }
  }
}
.column-02{
  @media(min-width:768px){
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    figure{
      width: 300px;
    }
    P{
      width: calc(100% - 330px);;
    }
  }
}
</style>